angular.module('components.media.video', [
  'stack',
  'components.media.VideoController'
])

/**
 * The componentVideo provides a preview
 * of the video item type
 *
 * @class componentVideo
 * @constructor
 * @module components.media.video
 * @example
 *   <component-video
 *     model="form.model">
 *   </component-video>
 */
.directive('componentVideo', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: 'components/media/video/video.html',
      controller: 'VideoController'
    };
  }
]);
